import { Routes, Route } from "react-router-dom";
import AlarmGamePage from "./pages/AlarmGamePage";
import BalanceGamePage from "./pages/BalanceGamePage";
import ListPage from "./pages/ListPage";
import NotFoundPage from "./pages/NotFoundPage";
import QuestionBombPage from "./pages/QuestionBombPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<AlarmGamePage />} />
      <Route path="/list" element={<ListPage />} />
      <Route path="/question-bomb" element={<QuestionBombPage />} />
      <Route path="/balance-game" element={<BalanceGamePage />} />
      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
